export const TYPE_DEPOSIT = 'deposit'
export const TYPE_WITHDRAWAL = 'withdrawal'
export const TYPE_BONUSES_NOBONUS = 'noBonus'

// History
export const TYPE_HISTORY = 'history'
export const TYPE_HISTORY_DEPOSIT = 'payin'
export const TYPE_HISTORY_WITHDRAWAL = 'payout'
export const TYPE_HISTORY_ALL = 'all'

// Terminals
export const TYPE_PAYMENT_TERMINAL = 'terminal'
export const TERMINAL_NAME_CITY = 'city24'
export const TERMINAL_NAME_EASYPAY = 'easy_pay'
export const TERMINAL_TITLE_CITY = 'City24'
export const TERMINAL_TITLE_EASYPAY = 'EasyPay'

//method name
export const METHOD_NAME_APPLE_H2H = 'applepay_h2h'

//cars icon name
export const CARD_ICON_DEFAULT = 'credit-card'
export const CARD_ICON_VISA = 'visa'
export const CARD_ICON_MASTERCCARD = 'mastercard'

export const WITHDRAWAL_DECLINE_ERROR = {
  PROCCESS_ERROR: 'process_error',
  DOCUMENT: 'documents',
  CARDS: 'cards',
  NO_DEPS: 'no_deps',
  BORROWED_DETAILS: 'borrowed_details',
  MULTIACCOUNT: 'multiaccount',
  BLACK_LIST: 'black_list',
  PRIZE_CHECK: 'prize_check',
  USER_DEMAND: 'user_demand',
  OTHER: 'other',
}

export const VIDEO_SRC = {
  CITY: 'https://www.youtube.com/embed/SuksSEuXyzI?si=TvaSa8b7z-pxPnVG&autoplay=1&rel=0&muted=1',
  EASYPAY: 'https://www.youtube.com/embed/eMyUJFClBZ8?si=XUNEo-NhpdXGWQ4M&autoplay=1&rel=0&muted=1',
}
